import { CheckBox, useConfirmationModal } from '@room-match/shared-ui-components';
import { CustomTypograhy } from 'pages/Representatives/components/Typograhy';
import React from 'react';

interface Props {
  aggreed: boolean;
  setAgreed: (agreed: boolean) => void;
}

const NumberConsent: React.FC<Props> = ({ aggreed, setAgreed }) => {
  const { handleOpen, handleSetMessage, ConfirmationModal, isOpen, handleClose } = useConfirmationModal({
    type: 'warning',
  });

  return (
    <div style={{ display: 'flex', alignItems: 'start' }}>
      <CheckBox
        style={{ marginTop: 10, padding: 0 }}
        checked={aggreed}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          if (!e.target.checked) {
            handleSetMessage(
              'Disable Text/SMS Notifications',
              'By selecting to STOP receiving Text/SMS Notifications. You will not receive Audition, Self Tape and other important project. Account and System notifications in the future.',
            );
            handleOpen();
          } else setAgreed(e.target.checked);
        }}
      />
      <div style={{ marginTop: 8, display: 'flex', flexDirection: 'column' }}>
        <CustomTypograhy style={{ margin: 5, maxWidth: 400, marginLeft: 10, fontSize: 14 }}>
          I opt-in to receive sms/text messages from casting.com
        </CustomTypograhy>
        <CustomTypograhy style={{ margin: 5, maxWidth: 400, textAlign: 'justify', marginLeft: 10, fontSize: 12 }}>
          By opting in, I expect to be sent messages every time I receive a self tape or studio audition request as well
          as receive other activity messages relating to my auditions. Additionally I opt to receive messages from my
          representative or the client directly related to my auditions and projects and to receive important profile or
          account updates from casting.com.
        </CustomTypograhy>
        <CustomTypograhy style={{ margin: 5, maxWidth: 400, textAlign: 'justify', marginLeft: 10, fontSize: 12 }}>
          Message and data rates may apply. reply STOP to opt out.
        </CustomTypograhy>
      </div>
      <ConfirmationModal
        onClose={() => {
          handleClose();
        }}
        onConfirm={function (): void {
          setAgreed(false);
        }}
      />
    </div>
  );
};

export default NumberConsent;
